import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { DataBroker } from './Util/DataBroker';

import Menu from './Components/Menu';
import Shiur from './Pages/Shiur';
import Prakim from "./Pages/Prakim";
import Perek from "./Pages/Perek";
import Settings from "./Pages/Settings";


import './App.css';

ReactGA.initialize('G-RZHDQ6DQSN');


function App() {
  const [stateVersion, setStateVersion] = useState("0.0");

  useEffect(() => {
    DataBroker.checkVersion(setStateVersion);

    if (!localStorage.getItem('tfilulari/settings'))
      localStorage.setItem('tfilulari/settings', '{ "fontSize":24, "thBirthday": [] }');
    
  }, []);




  return (
    //test
    <BrowserRouter>
        <Routes>
						<Route index                element={ <Menu version={stateVersion} /> } />
            <Route path=":type/"        element={ <Shiur /> } />
            <Route path="pr/:type"      element={ <Prakim /> } />
            <Route path="pr/:type/:id"  element={ <Perek /> } />
            <Route path="st/"           element={ <Settings /> } />
            <Route path="*"             element={ <Menu version={stateVersion} /> } />
        </Routes>
    </BrowserRouter>
  );
}

export default App;
